import { useQuery } from 'react-query';
import { useTokenizedApi } from '../useTokenizedApi';
import { usePersonalProfile } from '../entities/usePersonalProfile';

const everything = () => true;

export function useActivityOverview({
  profileId,
  overviewFilter = everything,
} = {}) {
  const tokenizedApi = useTokenizedApi();

  const personalProfile = usePersonalProfile();
  profileId = profileId || personalProfile?.id;

  return useQuery({
    ...tokenizedApi.activity.activityOverviewQuery({
      profileId,
    }),
    select: (activities) => activities.filter(overviewFilter),
  }).data;
}
